import { ApiContentElementsResponse, ContentInterface } from '../interfaces';

export function mapContentElementsResponse(apiContentElements: ApiContentElementsResponse): ContentInterface[] {
    return apiContentElements.elements[0].content;
}
